module.exports = __webpack_public_path__ + "img/companyInside6.5bb6a10a.jpg";